import { styled } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";
// I hate the use of "any" here, but MUI seems to rely on "any" for a lot of things with their Pickers components.
export const StyledDateCalendar = styled(DateCalendar)(({ theme }) => ({
    ".MuiDateCalendar-root": {
        width: theme.typography.pxToRem(310),
        height: theme.typography.pxToRem(305),
    },
}));
